import { COLORS } from 'constants/index';
import typography from '../typography';

const MuiCard = {
  root: {
    position: 'relative',
    backgroundColor: COLORS.WHITE,
    borderRadius: '18px 18px 0 0',
    padding: '16px 16px 0 16px',
  },
  title: {
    ...typography.h2,
    textTransform: 'none'
  },
  action: {
    marginRight: 0,
    marginTop: 0,
  },
};

export default MuiCard;